/**
 * Available ticket properties that can be used in email subject templates.
 * Each property includes a label for display, the value path for insertion,
 * and an example to show in the preview.
 */

import type {
  EmailSubjectTicketPropertyOption,
  TestEmailTicketAction
} from './EmailSubjectTemplate.types';

export const EMAIL_SUBJECT_TICKET_PROPERTIES: EmailSubjectTicketPropertyOption[] =
  [
    {
      label: 'Ticket ID',
      value: 'id',
      example: '9999999',
      description: 'Unique ticket identifier'
    },
    {
      label: 'Action',
      value: 'action',
      example: 'Created',
      description:
        'Action taken on the ticket (e.g., Created, Acknowledged, Closed)'
    },
    {
      label: 'Acknowledged Date',
      value: 'acknowledged',
      example: '2025-10-21 01:15:00',
      description: 'Date when the ticket was acknowledged'
    },
    {
      label: 'Assignee Name',
      value: 'assignee_name',
      example: 'Jane Smith',
      description: 'Assigned team member'
    },
    {
      label: 'Assignee Email',
      value: 'assignee_email',
      example: 'jane.smith@example.com',
      description: 'Assigned team member email'
    },
    {
      label: 'Category',
      value: 'category',
      example: 'Malware',
      description: 'Ticket category'
    },
    {
      label: 'Created Date',
      value: 'created',
      example: '2025-10-20 14:30:00',
      description: 'Ticket creation date'
    },
    {
      label: 'Customer Ticket ID',
      value: 'customer_ticket_id',
      example: 'T-12345678',
      description: 'Customer ticket identifier'
    },
    {
      label: 'Last Updated Date',
      value: 'last_updated',
      example: '2025-10-21 01:15:00',
      description: 'Date when the ticket was last updated'
    },
    {
      label: 'Priority',
      value: 'priority',
      example: 'P1',
      description: 'Ticket priority level'
    },
    {
      label: 'Organization Name',
      value: 'organization_name',
      example: 'Acme Corp',
      description: 'Organization name'
    },
    {
      label: 'Organization Code',
      value: 'organization_code',
      example: 'acp',
      description: 'Organization short code'
    },
    {
      label: 'Status',
      value: 'status',
      example: 'Open',
      description: 'Current ticket status'
    },
    {
      label: 'Tags',
      value: 'tags',
      example: 'phishing, urgent',
      description: 'Ticket tags (comma-separated)'
    },
    {
      label: 'Ticket Type',
      value: 'type',
      example: 'Threat',
      description: 'Type of ticket (Threat or Service)'
    },
    {
      label: 'Title',
      value: 'title',
      example: 'Test Ticket - Suspicious Activity Detected',
      description: 'Ticket title'
    },
    {
      label: 'User',
      value: 'user',
      example: 'Joe Admin',
      description: 'User performing the action'
    }
  ];

export const EMAIL_SUBJECT_DEFAULT_TEMPLATE =
  'Pondurance Notifications: [{{id}}] Threat Ticket {{action}} ({{priority}})';

export const EMAIL_SUBJECT_DEFAULT_TEMPLATE_PLACEHOLDER = `e.g., ${EMAIL_SUBJECT_DEFAULT_TEMPLATE}`;

export const EMAIL_SUBJECT_MAX_LENGTH = 512;

export const EMAIL_SUBJECT_TEST_TICKET_ACTIONS: {
  value: TestEmailTicketAction;
  label: string;
}[] = [
  { value: 'created', label: 'Create' },
  { value: 'remediated', label: 'Update Status (Remediate)' },
  { value: 'closed', label: 'Close' },
  { value: 'acknowledged', label: 'Acknowledge' }
];
